import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import ComparisonChartsContainer from './comparisonCharts/ComparisonChartsContainer';
import ComparisonTable from './ComparisonTable';
import { BidPXClass, ComparisonData } from './comparisonTable.config';
import { useBidComparison } from './hooks/useBidComparison';
import { ToggleChartTableBtnGroup } from './ToggleChartTableBtnGroup';
import { Button } from '../../../../ui-kit';
import { basisPointsToPercent } from '../../../deals/DealStages/EventActionCards/utils';

const ComparisonViewTab = () => {
  const {
    selectedIds,
    handleClearSelectedListingIds,
    comparisonData,
    bidPX,
    carveAnalyticsCfg,
    loading,
  } = useBidComparison();

  const [isChart, setIsChart] = useState<boolean>(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !comparisonData.length) {
      setTimeout(() => navigate('/marketplace/active_trades/bids'), 3000);
    }
  }, [loading, comparisonData.length]);

  return (
    <>
      {!!comparisonData.length && (
        <>
          <div className="w-full">
            <div className="mb-[10px] flex w-full items-center justify-between">
              <span className="text-[16px] font-normal leading-[24px] text-white">
                Entire pool carves
              </span>
            </div>
            <div className="mb-8 flex w-full items-center justify-between border-b border-b-gray-900 pb-2">
              {carveAnalyticsCfg.map((section) => (
                <div className="flex items-center justify-start">
                  {section.map((cfg) => {
                    const colorKey =
                      cfg.value === bidPX.min ? 'min' : cfg.value === bidPX.max ? 'max' : 'white';
                    return (
                      <div className="mr-4 flex items-center justify-start">
                        <span className="mr-2 text-slate-400">{cfg.label}</span>
                        <span
                          className={`text-[12px] font-normal leading-[16px] ${BidPXClass[colorKey]}`}
                        >
                          {cfg.isBidPX
                            ? Number(basisPointsToPercent(cfg.value as number)).toFixed(0)
                            : cfg.value}
                          {cfg.isBidPX && '%'}
                        </span>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
          <div className="flex w-full items-center justify-center gap-4">
            <ToggleChartTableBtnGroup isChart={isChart} setIsChart={setIsChart} />
          </div>

          {!isChart ? (
            <>
              <div className="flex w-full justify-end">
                {selectedIds.length > 1 && (
                  <Button
                    onClick={handleClearSelectedListingIds}
                    className="mr-4 h-[35px] min-h-[35px] w-[150px]"
                    type="secondary"
                    size="medium"
                  >
                    Clear Selection
                  </Button>
                )}
              </div>
              <ComparisonTable data={comparisonData as ComparisonData[]} bidPX={bidPX} />
            </>
          ) : (
            <ComparisonChartsContainer comparisonData={comparisonData} />
          )}
        </>
      )}
      {!loading && !comparisonData.length && (
        <div className="mb-5 flex h-[70vh] w-full flex-col items-center justify-start">
          <div className="mb-2 text-[18px]">No Data to Compare</div>

          <div className="mb-[100px] text-[14px]">Redirecting to Bids Table</div>
          <Button
            type="primary"
            label="Select Bid to compare"
            className=""
            onClick={() => navigate('/marketplace/active_trades/bids')}
          >
            Select Bids for comparison
          </Button>
        </div>
      )}
    </>
  );
};

export default ComparisonViewTab;
